import { render, staticRenderFns } from "./saleman.vue?vue&type=template&id=204f6e6b&scoped=true"
import script from "./saleman.vue?vue&type=script&lang=js"
export * from "./saleman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f6e6b",
  null
  
)

export default component.exports